<template>
  <div
    data-testid="license-top-bar"
    class="flex w-full shrink-0 items-center justify-between gap-4 bg-red-primary px-4 text-white-primary sm:px-6"
  >
    <div class="flex min-w-0 items-center gap-2">
      <ConstructionIcon class="h-5 w-5 shrink-0" />
      <p class="min-w-0 truncate text-button-primary">
        {{ t("license.bar.text") }}
      </p>
    </div>
    <a
      v-if="contactEmail"
      data-testid="license-contact-support"
      :href="mailtoHref"
      class="shrink-0 whitespace-nowrap rounded-md bg-white-primary px-4 py-1.5 text-button-secondary text-black-primary transition-opacity hover:opacity-90"
    >
      {{ t("license.contact_support") }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Locales, MessageSchema } from "@/i18n";
import { storeToRefs } from "pinia";
import ConstructionIcon from "@/icons/construction.svg";
import { useLicenseStore } from "@/stores/settings/license";
import { buildSupportMailto } from "@/utils/licenseSupport";

const { t } = useI18n<{ message: MessageSchema }, Locales>();

const licenseStore = useLicenseStore();
const { contactEmail } = storeToRefs(licenseStore);

const mailtoHref = computed(() => buildSupportMailto(contactEmail.value));
</script>
